// src/stores/auth.js
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { firebaseSetup } from '@/config/firebase'
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  updateProfile,
  onAuthStateChanged,
  setPersistence,
  //browserLocalPersistence,
  browserSessionPersistence
} from 'firebase/auth'
import { useNotification } from '@/composables/useNotification'
//import { useUserStore } from './config/userStore'

//import { useUserStore } from './config/userStore'

const auth = getAuth(firebaseSetup)

export const useAuthStore = defineStore('authStore', () => {
  const { addNotification, setLoading } = useNotification()

  const user = ref(JSON.parse(sessionStorage.getItem('user')))
  //const user = ref(null)

  const isInitialized = ref(false)

  const initializeAuth = async () => {
    await setPersistence(auth, browserSessionPersistence)
    //console.log('Persistence set to LOCAL');

    return new Promise((resolve) => {
      onAuthStateChanged(auth, (currentUser) => {
        if (currentUser) {
          setUser(currentUser)
        } else {
          clearUser()
        }
        isInitialized.value = true
        resolve()
      })
    })
  }

  const createAccount = async (email, password) => {
    setLoading(true)
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password)

      console.log('user =', userCredential)
      setUser(userCredential.user)
    } catch (e) {
      addNotification('error', e.message)
    } finally {
      setLoading(false)
    }
  }

  const login = async (email, password) => {
    setLoading(true)
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password)

      if (userCredential) {
        setUser(userCredential.user)
        return userCredential.user.uid
      }

      return false
      // if (userCredential) {
      //   const userStore = useUserStore()
      //   userStore.updateUserLogin(userCredential.user.uid)
      // }
    } catch (e) {
      addNotification('error', e.message)
    } finally {
      setLoading(false)
    }
  }

  const setUser = (currentUser) => {
    user.value = currentUser
    sessionStorage.setItem('user', JSON.stringify(currentUser))
  }

  const clearUser = () => {
    user.value = null
    sessionStorage.removeItem('user')
  }

  const logout = async () => {
    setLoading(true)
    try {
      await signOut(auth)
      clearUser()
    } catch (e) {
      addNotification('error', e.message)
    } finally {
      setLoading(false)
    }
  }

  const update = async (payload) => {
    setLoading(true)
    const { displayName } = payload
    try {
      await updateProfile(auth.currentUser, { displayName })
      setUser(auth.currentUser)
    } catch (e) {
      addNotification('error', e.message)
    } finally {
      setLoading(false)
    }
  }

  const getToken = async () => {
    if (auth.currentUser) {
      setLoading(true)
      try {
        const token = await auth.currentUser.getIdToken(true) // Force refresh the token
        //console.log('token', token);
        return token
      } catch (e) {
        addNotification('error', e.message)
        throw new Error('User is not authenticated')
      } finally {
        setLoading(false)
      }
    } else {
      addNotification('error', 'User is not authenticated')
      throw new Error('User is not authenticated')
    }
  }

  const refreshToken = async () => {
    const user = auth.currentUser
    if (user) {
      await user.getIdToken(true) // Force refresh the token
    }
  }

  const isLoggedIn = computed(() => !!user.value)

  return {
    user,
    isLoggedIn,
    isInitialized,
    createAccount,
    login,
    setUser,
    clearUser,
    logout,
    update,
    getToken,
    refreshToken,
    initializeAuth
  }
})
